export default __webpack_public_path__ + "static/media/Vacay-Add-Listing.3b19dd51.png";